// Shipment Internal model
import { getStorage } from "store/local";
import proxy from "api/proxy";
import moves from "./ModelStockRequestLine";
import tools from "tools/common";
import ComponentAddProduct from "./component/AddProductBarcode";
import ValidateProducts from "./component/ValidateProducts";

let today = tools.fmtDate2Tryton(new Date());

async function getFromLocation() {
  const session = getStorage("ctxSession");

  const { data: userData } = await proxy.search(
    "res.user",
    [["login", "=", session.login]],
    ["id", "warehouse.name"],
    1,
  );

  if (userData?.[0]?.["warehouse."]) {
    return userData[0]["warehouse."];
  }

  const { data: configData } = await proxy.search(
    "dash.app.shipment_internal",
    [],
    ["id", "warehouse_default.name"],
  );

  if (configData?.[0]?.["warehouse_default."]) {
    return configData[0]["warehouse_default."];
  }

  alert(
    "error: debe definir la bodega para el usuario, \n consulta con el area administrativa",
  );
}

async function getToLocation() {
  const session = getStorage("ctxSession");
  let fields_names = ["warehouse.storage_location.name"];
  const { data } = await proxy.search(
    "res.user",
    [["login", "=", session.login]],
    fields_names,
    1,
  );
  try {
    const location = data[0]["warehouse."]["storage_location."];
    return location;
  } catch (error) {
    alert(
      "error: debe definir la bodega para el usuario, \n consulta con el area administrativa",
    );
  }
}

const searchLocation = () => {
  const dom = [["type", "=", "storage"]];
  return dom;
};

function getFilters() {
  const session = getStorage("ctxSession");

  return {
    today: [
      ["create_date", ">=", `${today} 00:00:00`],
      ["create_uid", "=", session.user],
    ],
  };
}

function searchRequested(value) {
  const search = [
    "OR",
    [["party.name", "ilike", `%${value}%`]],
    [["party.id_number", "ilike", `${value}%`]],
  ];
  return search;
}

function visibleWait(field, record) {
  const session = getStorage("ctxSession");
  return (
    (record.number === null && record.moves?.size > 0) ||
    record.state === "draft" ||
    (record.state === "request" &&
      record.requested_by?.id !== session.user_employee)
  );
}

const visibleRequest = (field, record) => {
  if (!record) return false;
  const session = getStorage("ctxSession");
  const isCreator =
    !record.requested_by ||
    record.requested_by?.id === session.user_employee;
  return (
    ((record.number === null && record.moves?.size > 0) ||
      record.state === "draft") &&
    isCreator
  );
}

function readOnlyField(record) {
  return record.state !== "draft";
}

function showValidate(_, record) {
  if (!record) return false;
  const session = getStorage("ctxSession");
  return (
    record.state === "shipped" &&
    record.requested_by?.id !== session.user_employee
  );
}
const visibleMoves = (field, record) => {
  return record?.state === "draft" || !record.state;
};
const visibleBarcode = (field, record) => {
  return record?.state === "draft";
};
function visibleOutgoingMoves(field, record) {
  return (
    record.state === "request" ||
    record.state === "waiting" ||
    record.state === "assigned" ||
    record.state === "shipped" ||
    record.state === "done"
  );
}
const visibleIncomingMoves = (field, record) => {
  return (
    record.state === "assigned" ||
    record.state === "shipped" ||
    record.state === "done"
  );
};

function visibleAssign(field, record) {
  return record.state === "waiting";
}

function visibleShipped(field, record) {
  return record.state === "assigned";
}

async function getView() {
  const toLocation = await getToLocation();

  return {
    model: "stock.shipment.internal",
    row_selectable: false,
    form_action: ["add", "edit"],
    table_action: ["edit", "add"],
    domain: toLocation ? [["to_location", "=", toLocation.id]] : [],
    activeSearch: true,
    filters: getFilters,
    orderBy: [["number", "DESC"]],
    note: true,
    webfields: {
      number: { type: "char", readOnly: true, searchable: true },
      company: {
        default: getStorage("ctxSession") && getStorage("ctxSession").company,
      },
      from_location: {
        type: "many2one",
        recSearch: searchLocation,
        model: "stock.location",
        required: true,
        default: getFromLocation,
        readOnly: readOnlyField,
      },
      to_location: {
        type: "many2one",
        model: "stock.location",
        default: getToLocation,
        // readOnly: () => config.mode === "bard",
      },
      requested_by: {
        type: "many2one",
        model: "company.employee",
        // recSearch: searchRequested,
        required: true,
        readOnly: readOnlyField,
      },
      effective_date: {
        type: "date",
        readOnly: readOnlyField,
        required: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },
      create_uid: { type: "many2one", model: "res.user", readOnly: true },
      reference: { type: "char", readOnly: readOnlyField },
      moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        required: true,
        readOnly: readOnlyField,
        visible: visibleMoves,
      },
      outgoing_moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        visible: visibleOutgoingMoves,
        title: "Salida",
      },
      incoming_moves: {
        type: "one2many",
        model: "stock.move",
        ctxView: moves,
        visible: visibleIncomingMoves,
        title: "Entrada",
      },
      code: {
        type: "custom",
        component: ComponentAddProduct,
        visible: visibleBarcode,
      },
      request_button: {
        type: "button",
        button_method: "request",
        visible: visibleRequest,
      },
      wait: {
        type: "button",
        button_method: "wait",
        visible: visibleWait,
      },
      assign: {
        type: "button",
        button_method: "assign",
        visible: visibleAssign,
      },
      ship: {
        type: "button",
        button_method: "ship",
        visible: visibleShipped,
        label: "stock.shipment.internal.ship",
      },
      barcode_validate: {
        type: "button_custom_modal",
        Component: ValidateProducts,
        color: "lime",
        visible: showValidate,
        size: "w-48",
        button_ok: false,
      },
    },
    webtree: [
      { name: "number", width: "20%" },
      { name: "from_location", width: "20%" },
      { name: "to_location", width: "35%" },
      { name: "effective_date", width: "10%" },
      { name: "state", width: "10%" },
      { name: "requested_by", width: "10%" },
    ],
    webform: [
      {
        id: "infoShipment",
        grid: [
          { name: "reference" },
          { name: "effective_date" },
          { name: "number" },
        ],
        size: [1, 3],
        span: "col-span-1",
      },
      {
        id: "infoShipment2",
        grid: [{ name: "from_location" }, { name: "to_location" }],
        size: [1, 2],
        span: "col-span-1",
      },
      { name: "code" },
      { name: "moves", component: "modal" },
      { name: "outgoing_moves", component: "modal" },
      { name: "incoming_moves", component: "modal" },
      { name: "requested_by" },
      { name: "state" },
      { name: "request_button" },
      { name: "wait" },
      { name: "assign" },
      { name: "ship" },
      { name: "barcode_validate" },
    ],
  };
}

export default { ctxView: getView };
